// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-7ba7c0445636b3710cb9.js";
	// return url for filenames based on template
	return "" + ({"271":"__federation_expose_filter_input","522":"__federation_expose_document_list","661":"__federation_expose_filter_select","943":"__federation_expose_handlers"}[chunkId] || chunkId) + "-" + {"231":"c95c055abdde965ba145","271":"76431eee8fd6ef8f5e1b","522":"a11d14b42fdc8113d5c6","661":"c4b732f348a5449c2343","943":"163eb81ccae230544f86"}[chunkId] + ".js";
};